export const ON_LINE_NOTIFICATION = 'SS@system_online'
export const SCENE_LOADED = 'SS@scene_loaded'
export const TITLES_LOADED = 'SS@titles_scene_loaded'
export const SIMPLE_HIT = 'SS@hit'
export const GAME_OVER = 'SS@game_over'
export const GAME_WON = 'SS@game_won'
export const ENEMY_DOWN = 'SS@enemy_down'
export const FROZEN = 'SS@ufo_frozen'
export const COILED = 'SS@ufo_coiled'
export const OVERCHARGED = 'SS@ufo_overcharged'
export const GROWN = 'SS@ufo_magnified'
export const TELEPORTED = 'SS@ufo_teleported'
export const IMPULSE_ON = 'SS@ufo_impule_on'
export const IMPULSE_OFF = 'SS@ufo_impulse_off'
export const THE_END_BEGINS = 'SS@the_end_begins'
export const THE_END_ENDS = 'SS@the_end_ends'